angular.module( 'acme.view.application.pos.create.pages.forms.navigation', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.navigation.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsNavigation = {
        name: 'application.pos.create.pages.forms.navigation',
        url: '/navigation',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsNavigationController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/navigation/navigation.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(posCreatePagesFormsNavigation);
});
